import { render, staticRenderFns } from "./TaskTypePlain.vue?vue&type=template&id=75fa61ca"
import script from "./TaskTypePlain.vue?vue&type=script&lang=js"
export * from "./TaskTypePlain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports